import {
    $, _, addAction, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    const $searchIcon = $('.search-icon');
    let $form = $('.header-nav .search-form');
    const minSearchChars = 3;
    const speed = 100;
    const HAS_RESULTS_CLASS = 'search-form--has-results';
    if ($form.length) {
        $searchIcon.click(() => {
            $form.toggleClass('search-form--show');
            $form.on('transitionend', () => {
                $form.find('.search-form__input').focus();
            });
        });
    } else {
        $form = $('.page-header .search-form');
        $searchIcon.click(() => {
            $('.page-header .search-form__input').focus();
        });
    }
    if (!$form.length) {
        return;
    }

    const $results = $form.find('.search-form__results');
    let currentSearch = '';
    $form.find('.search-form__input').on(
        'keyup',
        _.throttle((event) => {
            const text = event.target.value;
            if (currentSearch === text) {
                return;
            }
            if (text.length < minSearchChars) {
                $results.html('');
                $form.removeClass(HAS_RESULTS_CLASS);
                currentSearch = '';
                return;
            }

            currentSearch = text;
            $.get(`/?predictive=1&s=${encodeURIComponent(text)}`, (data) => {
                if (currentSearch) {
                    $results.html(data);
                    $form.addClass(HAS_RESULTS_CLASS);
                }
            });
        }, speed),
    );
});
